import { createFileRoute } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useTranslate } from "@/hooks/use-translate";
import SaleReturnTable from "@/components/sale-return/sale-return-table";
import { useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/(dasboard)/orders/returns/")({
  component: SaleReturnsPage,
});

function SaleReturnsPage() {
  const { t } = useTranslate();
  const navigate = useNavigate();

  return (
    <section>
      <header className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-semibold">{t("Sales returns")}</h2>

        <div className="flex items-center gap-2">
          <Button
            onClick={() => {
              navigate({ to: `/orders/returns/create` });
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Process return")}
          </Button>
        </div>
      </header>
      <SaleReturnTable />
    </section>
  );
}
